import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {map, withLatestFrom} from 'rxjs/operators';
import {AppState} from '../states/app.state';
import {BelegEntitiesActions} from '../actions/beleg-entities.actions';
import {DubletteSelectors} from '../selectors/dublette.selectors';
import {PdfViewerSlot} from '../../enums/pdfviewerslot.enum';

@Injectable()
export class PreviewDialogEffects {
  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
  ) {}

  readonly closePreviewDialog$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BelegEntitiesActions.closePreviewDialog),
      withLatestFrom(this.store.select(DubletteSelectors.isHandleDubletteDialogOpen)),
      map(([, isDubletteDialogOpen]) =>
        BelegEntitiesActions.closeBelegPreviewDialog({
          resetPdfViewerData: !isDubletteDialogOpen,
          viewerSlot: PdfViewerSlot.Dialog,
        }),
      ),
    ),
  );
}
